import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from './createBaseQuery';

export interface ITagCategory {
  id: string;
  name: string;
  description?: string;
}

export const tagsCategoriesApi = createApi({
  reducerPath: 'tagsCategoriesApi',
  baseQuery: createBaseQuery(),
  tagTypes: ['Tags'],
  endpoints: (builder) => ({
    getTagsCategories: builder.query<ITagCategory[], void>({
      query: () => ({
        url: '/tags-categories',
        method: 'GET',
      }),
      providesTags: ['Tags'],
    }),

    createTagCategory: builder.mutation<ITagCategory, Omit<ITagCategory, 'id'>>({
      query: (data) => ({
        url: '/tags-categories',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Tags'],
    }),

    updateTagCategory: builder.mutation<ITagCategory, ITagCategory>({
      query: (data) => ({
        url: `/tags-categories/${data.id}`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Tags'],
    }),

    deleteTagCategory: builder.mutation<void, string>({
      query: (id) => ({
        url: `/tags-categories/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Tags'],
    }),
  }),
});

export const {
  useGetTagsCategoriesQuery,
  useCreateTagCategoryMutation,
  useUpdateTagCategoryMutation,
  useDeleteTagCategoryMutation,
  useLazyGetTagsCategoriesQuery
} = tagsCategoriesApi;
